import { Button } from 'antd';
import styled from 'styled-components';
import { AIGradientColors, MediaQuery, NeutralColors } from 'theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 16px;
  overflow: auto;
  max-height: 100%;

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    .fms-conversations-menu-icon {
      opacity: 1;
      visibility: visible;
    }
  }
`;

const TitleContainer = styled.h3`
  display: flex;
  align-items: center;
  margin: 0 0 24px;
  height: 20px;
  background: ${AIGradientColors[60]};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const NewButton = styled(Button)`
  border-radius: 40px;
  border: 1px solid ${NeutralColors[30]};
  background: ${NeutralColors[0]};
  display: flex;
  align-items: center;
  height: 40px;

  span {
    display: flex;
    align-items: center;
  }
`;

export { Container, NewButton, TitleContainer };
